import { render, staticRenderFns } from "./publicUpload.vue?vue&type=template&id=6e95d994&scoped=true"
import script from "./publicUpload.vue?vue&type=script&lang=js"
export * from "./publicUpload.vue?vue&type=script&lang=js"
import style0 from "./publicUpload.vue?vue&type=style&index=0&id=6e95d994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e95d994",
  null
  
)

export default component.exports